import { Fragment } from 'react';
import { Text, View } from '@react-pdf/renderer';
import intl from 'react-intl-universal';
import { styles } from '../styles';

const InvoiceGreetings = () => {
  return (
    <Fragment>
      <View style={styles.invoiceGreetings}>
        <Text style={styles.invoiceGreetingsText}>
          {intl.get('billing_invoice_text_greetings')}
        </Text>
      </View>
    </Fragment>
  );
};

export default InvoiceGreetings;
